var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.967,
    height: 61.045,
    viewBox: "0 0 60.967 61.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_351",
    x: 16.986,
    y: 16.343,
    width: 43.98,
    height: 44.702,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File_Upload_Icon",
    "data-name": "File Upload Icon",
    transform: "translate(-323.43 -360.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_20525",
    "data-name": "Rectangle 20525",
    transform: "translate(323.43 360.47)",
    fill: "#fff",
    stroke: "#2c2d2e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0H27A14,14,0,0,1,41,14V38a7,7,0,0,1-7,7H7a7,7,0,0,1-7-7V7A7,7,0,0,1,7,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,1H27A13,13,0,0,1,40,14V38a6,6,0,0,1-6,6H7a6,6,0,0,1-6-6V7A6,6,0,0,1,7,1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_165263",
    "data-name": "Path 165263",
    transform: "translate(16343.963 -10293.803)",
    fill: "#d8d8d8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -15980.5712890625 10667.603515625 L -15992.0126953125 10667.603515625 L -15992.0126953125 10655.3818359375 C -15991.4501953125 10655.4482421875 -15990.6806640625 10655.5791015625 -15989.798828125 10655.837890625 C -15987.576171875 10656.4892578125 -15985.6357421875 10657.6328125 -15984.03125 10659.236328125 C -15981.0634765625 10662.203125 -15980.611328125 10665.9228515625 -15980.5712890625 10667.603515625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -15991.0126953125 10656.5615234375 L -15991.0126953125 10666.603515625 L -15981.642578125 10666.603515625 C -15981.6767578125 10666.2880859375 -15981.7275390625 10665.9423828125 -15981.80078125 10665.5751953125 C -15982.2412109375 10663.3466796875 -15983.2294921875 10661.451171875 -15984.73828125 10659.943359375 C -15986.884765625 10657.7978515625 -15989.3427734375 10656.9208984375 -15991.0126953125 10656.5615234375 M -15992.9765625 10654.314453125 C -15992.5029296875 10654.314453125 -15987.4423828125 10654.4130859375 -15983.32421875 10658.529296875 C -15978.9990234375 10662.8525390625 -15979.5966796875 10668.603515625 -15979.5966796875 10668.603515625 L -15993.0126953125 10668.603515625 L -15993.0126953125 10654.314453125 C -15993.0126953125 10654.314453125 -15993.0009765625 10654.314453125 -15992.9765625 10654.314453125 Z",
    stroke: "none",
    fill: "#2c2d2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(349.416 382.813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.99, -22.34)",
    filter: "url(#Ellipse_351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_351-2",
    "data-name": "Ellipse 351",
    transform: "translate(25.99 22.34)",
    fill: "#64f884",
    stroke: "#2d2e2f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.99,
    cy: 13.351,
    rx: 12.99,
    ry: 13.351,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.99,
    cy: 13.351,
    rx: 12.49,
    ry: 12.851,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "upload",
    d: "M13.684,6.268v9.538H11.976V6.268L9.208,9.037,8,7.83,12.83,3l4.83,4.83L16.453,9.037ZM6.854,17.514H18.806a.854.854,0,0,1,0,1.708H6.854a.854.854,0,0,1,0-1.708Z",
    transform: "translate(0.16 1.803)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.581558163b020e3ba9e7a9246b7ed759.svg";
export { ForwardRef as ReactComponent };